"use client"
import React, { useState, useEffect, Fragment } from "react";
import {
  Container,
  Row,
  Col,
  Collapse,
  Ratio,
  DropdownButton,
  Dropdown
} from "react-bootstrap";
import UralityImage from "@/components/shared/UralityImage";
import { useMediaQuery } from "react-responsive";
import EventCalendarLink from "@/components/shared/EventCalendarLink";
import MapLink from "@/components/shared/MapLink";
import { useConfig } from "@/lib/providers/ConfigProvider";

import "@/components/events/EventCalendarEntry.css";
import EventDateAndTime from "@/components/shared/EventDateAndTime";
import CollapseText from "@/components/shared/CollapseText";
import SocialLinks from "@/components/social/SocialLinks";
import VolunteerLink from "@/components/campaign/VolunteerLink";

var moment = require("moment");

const RecurringEventEntry = ({ event, date }) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  var oldEndDate = event.endDate ? moment(event.endDate.date) : null;
  var newEndDate = oldEndDate
    ? moment(date)
        .hours(oldEndDate.hour())
        .minutes(oldEndDate.minute())
    : date;
  return (
    <div className="default-card-wrapper recurring-event-entry">
      <div className="default-card-wrapper-content">
        <span>{date.format("MMMM DD, YYYY")}</span>
        <h4>{event.title}</h4>
        <EventCalendarLink
          event={{ ...event, startDate: date, endDate: newEndDate }}
          sm={isSm}
        />
      </div>
    </div>
  );
};

const EventCalendarEntry = ({
  name,
  wrapperClassName,
  queryDate,
  event,
  showMap,
  small,
  onClick,
  editMode = false,
  participants,
  overrideCta = null,
  showEventDate = true
}) => {
  const { webUrl } = useConfig();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [url, setUrl] = useState(null);
  const [recurringInstances, setRecurringInstances] = useState([]);

  const eventInstancesForMonth = (startDate, dates, month) => {
    var result = dates.filter(d => d.month() === month && d.isAfter(startDate));
    if (result.length === 0) {
      result = dates.filter(d => d.month() === month + 1);
      if (result.length > 0) {
        return [result[0]];
      } else {
        return result;
      }
    } else {
      return result;
    }
  };

  // TODO this code is creating a defect, come back to investigate JC 03252025
  useEffect(() => {
    if (event) {
      console.log("EventCalendarEntry useEffect event", event);
      const sd = moment(event.startDate?.date);
      const ed = event.endDate ? moment(event.endDate?.date) : null;
      setStartDate(sd);
      if (
        !event.multiDay &&
        event.recurringOptions &&
        event.recurringDates &&
        queryDate
      ) {
        var recurringDates = event.recurringDates.map(dt => moment(dt));
        // find the "next" instance and set it as startDate
        var isoDate = recurringDates.find(d => d.isAfter(queryDate));
        if (isoDate) {
          setStartDate(moment(isoDate));
        }
        var dateToCheck = isoDate ? moment(isoDate) : sd;
        var instances = eventInstancesForMonth(
          dateToCheck,
          recurringDates,
          queryDate.month()
        );
        setRecurringInstances(instances);
      }
      setEndDate(ed);
      var theUrl = `${webUrl}${event.owner?.resourceName}/events/${event.id}`;
      setUrl(theUrl);
    }
  }, [event, queryDate]);

  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  const [showRecurring, setShowRecurring] = useState(false);

  const cta = content => {
    if (content.eventType === "VOLUNTEER") {
      return <VolunteerLink name={name} event={content} />;
    } else if (
      content.socialProfile &&
      content.socialProfile.findIndex(sp => sp.type === "TICKETS") > -1
    ) {
      var tickets = content.socialProfile.find(sp => sp.type === "TICKETS");
      return (
        <a
          href={tickets.value}
          className="a content-card-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Event Page
        </a>
      );
    }
    if (
      content.socialProfile &&
      content.socialProfile.findIndex(sp => sp.type === "WEBSITE") > -1
    ) {
      var website = content.socialProfile.find(sp => sp.type === "WEBSITE");
      return (
        <a
          href={website.value}
          className="a content-card-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Event Page
        </a>
      );
    } else if (content.enableEventMap) {
      return (
        <a
          href={`${webUrl}${content.owner.resourceName}/events/${content.id}`}
          className="a content-card-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Event Page
        </a>
      );
    } else {
      return (
        <EventCalendarLink
          event={content}
          className="a content-card-cta"
          addIcon={false}
        />
      );
    }
  };

  const titleAndLink = content => {
    if (
      content.socialProfile &&
      content.socialProfile.findIndex(sp => sp.type === "WEBSITE") > -1
    ) {
      var website = content.socialProfile.find(sp => sp.type === "WEBSITE");
      return (
        <a href={website.value} target="_blank" rel="noopener noreferrer">
          <h4>{content.title}</h4>
        </a>
      );
    } else if (content.enableEventMap) {
      return (
        <a
          href={`${webUrl}${content.owner.resourceName}/events/${content.id}`}
          target="_self"
        >
          <h4>{content.title}</h4>
        </a>
      );
    } else {
      return <h4>{content.title}</h4>;
    }
  };

  const coverPhoto = event => {
    const eventDateDiv = startDate && showEventDate ? (
      <div className="event-date">
        <span className="month">{startDate.format("MMM")}</span>
        <span className="date">{startDate.format("Do")}</span>
      </div>
    ) : (
      <></>
    );

    if (
      event.coverPhotoAsset &&
      event.coverPhotoAsset.assetSource === "URALITY"
    ) {
      return (
        <Ratio aspectRatio={isSm || small ? "16x9" : "16x9"}>
          <div className={"event-cover-photo" + (isSm || small ? " sm" : "")}>
            {(isSm || small) && (
              <UralityImage
                imageId={event.coverPhotoAsset.id}
                size="md"
                tag="Card.Img"
              >
                <>{eventDateDiv}</>
              </UralityImage>
            )}
            {!isSm && !small && (
              <UralityImage imageId={event.coverPhotoAsset.id} size="sm">
                <>{eventDateDiv}</>
              </UralityImage>
            )}
          </div>
        </Ratio>
      );
    } else {
      return (
        <Ratio aspectRatio={isSm || small ? "16x9" : "16x9"}>
          <div
            className={
              "event-cover-photo-missing" + (isSm || small ? " sm" : "")
            }
          >
            <span
              className="material-icons"
              style={{ color: "#FFFFFF", fontSize: "6rem" }}
            >
              today
            </span>
          </div>
        </Ratio>
      );
    }
  };

  const eventParticipantContent = participants => {
    return (
      <div className="participant-list">
        <h4>Featured</h4>
        {participants.map((participant, idx) => {
          return (
            <Fragment key={idx}>
              <div className="event-participant-content">
                <div className="participant-photo">
                  <Ratio aspectRatio="16x9">
                    <UralityImage
                      name={name}
                      imageId={participant.profile.coverPhotoId}
                      id={`${participant.id}-cover-photo`}
                      key={`${participant.id}-cover-photo`}
                    />
                  </Ratio>
                </div>
                <div className="participant-text">
                  <h5>{participant.profile.displayName}</h5>
                  {participant.profile.socialProfile &&
                    participant.profile.socialProfile.length > 0 && (
                      <SocialLinks
                        socialProfile={participant.profile.socialProfile}
                        condensed={!isSm}
                      />
                    )}
                </div>
              </div>
              <CollapseText
                text={participant.profile.description}
                maxLength={200}
              />
            </Fragment>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className={`event-calendar-entry-card ${isSm || small ? "small" : ""}`}
    >
      {showMap && <span className="anchor" id={"anchor-" + event.id} />}
      <div
        className={`default-card-wrapper ${wrapperClassName ?? ""} ${
          onClick ? "clickable" : ""
        }`}
        onClick={evt => {
          if (!editMode) {
            onClick && onClick(evt, event);
          }
        }}
      >
        {isSm || small ? (
          <>
            {coverPhoto(event)}

            <div className="event-content-expanded">
                <Container>
                  <Row>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={small ? 12 : 8}
                      xl={small ? 12 : 8}
                    >
                      <div className="event-content-expanded-details">
                        {titleAndLink(event)}
                        <EventDateAndTime
                          className="upper-case"
                          startDate={startDate}
                          endDate={endDate}
                          multiDay={event.multiDay}
                          titleAs="span"
                          subtitleAs="span"
                        />
                        {event.location && (
                          <MapLink location={event.location} clickable={true} />
                        )}
                        <div className="event-content-separator" />
                        {event.subtitle && <h5>{event.subtitle}</h5>}
                        <div>
                          <span>
                            {event.description
                              ? event.description
                              : "No description provided."}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {participants && participants.length > 0 && (
                    <Row>
                      <Col>
                        <>{eventParticipantContent(participants)}</>
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-start"
                        }}
                      >
                        {recurringInstances.length > 0 && (
                          <button
                            className="recurring-event-button a with-icon"
                            onClick={evt => {
                              evt.preventDefault();
                              evt.stopPropagation();
                              setShowRecurring(!showRecurring);
                            }}
                          >
                            <span className="material-icons">repeat</span>
                            Recurring event
                          </button>
                        )}
                        <div className="flex-grow" />
                        {overrideCta ? overrideCta : cta(event)}
                      </div>
                    </Col>
                  </Row>
                </Container>
            </div>
          </>
        ) : (
          <>
            <div className="photo-and-content">
              {coverPhoto(event)}
              <div className="event-body">
                <div className="basic-details expanded">
                  <div className="date-and-recurring">
                    <EventDateAndTime
                      className="upper-case"
                      startDate={startDate}
                      endDate={endDate}
                      multiDay={event.multiDay}
                      titleAs="span"
                      subtitleAs="span"
                    />
                    <div className="flex-grow" />
                    {recurringInstances.length > 0 && (
                      <button
                        className="recurring-event-button a with-icon"
                        onClick={evt => {
                          evt.preventDefault();
                          evt.stopPropagation();
                          setShowRecurring(!showRecurring);
                        }}
                      >
                        <span className="material-icons">repeat</span>
                        Recurring event
                      </button>
                    )}
                  </div>
                  {titleAndLink(event)}
                  {event.location && (
                    <MapLink location={event.location} clickable={false} />
                  )}
                </div>
                <div className="event-content-expanded">
                    <Container>
                      <Row>
                        <Col
                          xs={12}
                          sm={12}
                          md={12}
                          lg={small ? 12 : 8}
                          xl={small ? 12 : 8}
                        >
                          <div className="event-content-expanded-details">
                            {event.subtitle && <h4>{event.subtitle}</h4>}
                            <div>
                              <span>
                                {event.description
                                  ? event.description
                                  : "No description provided."}
                              </span>
                            </div>
                          </div>
                        </Col>
                        {(isSm || small) && (
                          <Col>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start"
                              }}
                            >
                              {recurringInstances.length > 0 && (
                                <button
                                  className="recurring-event-button a with-icon"
                                  onClick={evt => {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    setShowRecurring(!showRecurring);
                                  }}
                                >
                                  <span className="material-icons">repeat</span>
                                  Recurring event
                                </button>
                              )}
                              <div className="flex-grow" />
                              {overrideCta ? overrideCta : cta(event)}
                            </div>
                          </Col>
                        )}
                      </Row>
                    </Container>
                    {participants && participants.length > 0 && (
                      <Container>
                        <Row>
                          <Col>
                            <>{eventParticipantContent(participants)}</>
                          </Col>
                        </Row>
                      </Container>
                    )}
                </div>
                {editMode && onClick ? (
                  <div className="upper-right">
                    <DropdownButton
                      className="ellipsis-dropdown"
                      align="end"
                      bsPrefix="none"
                      title=""
                    >
                      <Dropdown.Item
                        key="edit"
                        eventKey="edit"
                        onClick={() => onClick(event, "EDIT")}
                      >
                        <i className="fa-solid fa-pen"></i>Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        key="delete"
                        eventKey="delete"
                        onClick={() => onClick(event, "DELETE")}
                      >
                        <i className="fa-solid fa-trash"></i>Delete
                      </Dropdown.Item>
                    </DropdownButton>
                  </div>
                ) : (
                  <div className="calendar-link">
                    <div className="flex-grow" />
                    {overrideCta ? overrideCta : cta(event)}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      {recurringInstances && (
        <Collapse in={showRecurring}>
          <div className="recurring-instances">
            {recurringInstances.map((instance, index) => {
              return <RecurringEventEntry event={event} date={instance} />;
            })}
          </div>
        </Collapse>
      )}
    </div>
  );
};
export default EventCalendarEntry;
